/* Import Leverege Modules */
import Unit from '@leverege/unit';

/* Import Local Modules */
import Util from "./Util.js";
/* Initialize Constants */
const EMPTY = {};

/**
 * Takes a unit value and options, and returns an array of 
 * strings used to represent the value. 
 * @param {Object} measurement the value
 * @param {Number} measurement.value the numeric value
 * @param {String} measurement.unit the unit the value is in
 * @param {String} measurement.type the unit type, such as 'length'
 * @param {Object} options the format options
 * @param {String} options.type the type the formatter is applicable too
 * @param {String} options.unit the target unit type
 * @param {Number} options.maxDecimals the maximun number of decimals
 * @param {Boolean} options.fixed if true, pad the decimals with zero
 * @param {Boolean} options.sliding if true, use sliding units if available
 * @return {Array} returns an array of format objects (Strings or components)
 */
function format(measurement, options) {
  // Validate parameters
  if (measurement == null || measurement.value == null || measurement.unit == null) {
    return null;
  }

  // Get paremeters
  let {
    value: formattedValue,
    unit: formattedUnit
  } = measurement;
  const {
    fixed,
    maxDecimals,
    unit,
    unitType,
    sliding,
    baseUnit,
    localize
  } = options || EMPTY;

  // Optionally convert unit
  if (unit != null && !sliding) {
    formattedValue = Unit.convert(measurement.value, measurement.unit, unit);
    formattedUnit = options.unit;
  }
  if (sliding && baseUnit != null) {
    [formattedValue, formattedUnit] = Unit.convertSliding({
      unitType,
      fromValue: measurement.value,
      fromUnit: measurement.unit,
      toBaseUnit: baseUnit
    });
  }
  formattedUnit = Unit.getUnit(formattedUnit)?.displaySymbol || formattedUnit;
  if (localize) {
    formattedValue = fixed ? Number(formattedValue).toLocaleString(undefined, {
      maximumFractionDigits: maxDecimals,
      minimumFractionDigits: maxDecimals
    }) : Number(formattedValue).toLocaleString(undefined, {
      maximumFractionDigits: maxDecimals
    });
  }

  // Check if additional formatting is required
  if (typeof formattedValue !== 'number') {
    return [formattedValue, formattedUnit];
  }

  // Check if decimal formatting is configured
  if (maxDecimals == null) {
    formattedValue = formattedValue.toLocaleString();
    return [formattedValue, formattedUnit];
  }

  // Format decimals
  formattedValue = fixed ? Number(formattedValue).toFixed(maxDecimals) : Util.trimDecimals(formattedValue, maxDecimals);
  return [formattedValue, formattedUnit];
}
export default {
  format
};